// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1r1qo","inputWrap":"Table_inputWrap__2lmdW","col":"Table_col__395PG","bmiTooltip":"Table_bmiTooltip__2-aSW"};